<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<div>
			<h5>注:跟踪范围是车队车辆管理范围!</h5>
		</div>
		<div>
			<div class="inline-by" >
				<h5>保养即将到期</h5>
				<table class="dataintable">

					<tr class="tab_header">
						<td>序号</td>
						<td class="short0">车牌</td>
						<td class="short0">当前里程</td>
						<td class="short0">剩余</td>
						<td class="short0">次数</td>
					</tr>
					<tr v-for="(item, index) in list_baoyang" :key="index">
						<td>{{ item.id }}</td>
						<td class="short0">{{ item.c_no }}</td>
						<td class="short0">{{ item.distance }}Km</td>
						<td class="short0">{{ item.last }}Km</td>
						<td class="short0">{{ item.c_num }}</td>
					</tr>

				</table>
			</div>
		</div>
	</div>
</template>

<script>
	import api from '@/utils/type.js'

	import {
		Method_EasySelect,
		Method_EasyAdd
	} from '@/utils/loadhttpdata.js';

	export default {
		name: "baoxian",
		data() {
			return {
				element_loading: false,

				list_baoxian: [],
				list_baoxian_show: [],
				list_shenche: [],
				list_shenche_show: [],
				list_baoyang: [],

				show_bx: false,
				show_sc: false,
				show_by: false,

				maxpage: '',
				nowpage: 1,
				page_length: 20, //add 2022-01-25 默认分页长度
				all_count: 0,
				jumppage: '',
				
				maxpage2: '',
				nowpage2: 1,
				page_length2: 20, //add 2022-01-25 默认分页长度
				all_count2: 0,
				jumppage2: '',

			};
		},
		// created: function() {
		//   this.loaddata();
		// },
		mounted: function() {
			// console.log('保险 组件 mounted');
			this.loaddata();
		},
		// activated: function() {
		//   // console.log('保险 组件激活时调用 激活');
		//   this.loaddata();
		// },
		methods: {
			beforepage: function() {
				if (Number(this.nowpage) > 1) {
					this.nowpage--;
					this.refresh_data('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '已经是第一页',
						type: 'warning'
					});
				}
			},
			nextpage: function() {
				if (Number(this.nowpage) < Number(this.maxpage)) {
					this.nowpage++;
					this.refresh_data('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '已经是最后一页',
						type: 'warning'
					});
				}
			},
			refresh_data: function() {
				this.maxpage=Math.floor(this.list_baoxian.length/this.page_length)+1;
				let count = 0
				this.list_baoxian_show = [];
				let start_index=0;
				start_index=(this.nowpage - 1)*this.page_length;
				
				for (let i =start_index ; i < this.list_baoxian.length; i++) {
					if (count >= this.page_length) {
						break;
					}
					this.list_baoxian[i].row_num=i+1;
					this.list_baoxian_show.push(this.list_baoxian[i]);
					count++;
				}
			},
			beforepage2: function() {
				if (Number(this.nowpage2) > 1) {
					this.nowpage2--;
					this.refresh_data2('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '已经是第一页',
						type: 'warning'
					});
				}
			},
			nextpage2: function() {
				if (Number(this.nowpage2) < Number(this.maxpage2)) {
					this.nowpage2++;
					this.refresh_data2('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '已经是最后一页',
						type: 'warning'
					});
				}
			},
			refresh_data2: function() {
				this.maxpage2=Math.floor(this.list_shenche.length/this.page_length2)+1;
				let count = 0
				this.list_shenche_show = [];
				let start_index=0;
				start_index=(this.nowpage2 - 1)*this.page_length2;
				
				for (let i =start_index ; i < this.list_shenche.length; i++) {
					if (count >= this.page_length2) {
						break;
					}
					this.list_shenche[i].row_num=i+1;
					this.list_shenche_show.push(this.list_shenche[i]);
					count++;
				}
				
			
			},
			loaddata: function() {
				// console.log('加载数据')
				this.element_loading = true;
				this.list_baoxian = [];
				this.list_baoyang = [];
				this.list_shenche = [];

				this.$post(
					api.http_method, Method_EasySelect('data_exp_warningcar')
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					console.log(res);
					if (res.data.status == 1) {
						let t = res.data.data;
						// console.log(t);
						this.list_baoxian = t[0].bx_detail;
						this.list_baoyang = t[0].by_detail;
						this.list_shenche = t[0].sc_detail;
						// console.log(this.list_baoxian);
						// console.log(this.list_baoyang);
						// console.log(this.list_shenche);

						if (this.list_baoxian.length > 0) {
							this.show_bx = true;
							this.refresh_data()
						} else {
							this.show_bx = false;
						}

						if (this.list_baoyang.length > 0) {
							this.show_by = true;
						} else {
							this.show_by = false;
						}

						if (this.list_shenche.length > 0) {
							this.show_sc = true;
							this.refresh_data2();
						} else {
							this.show_sc = false;
						}

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});
			},
			fun_isNot: function(item) {
				this.element_loading = true;

				this.$post(
					api.http_method, Method_EasyAdd('data_exp_carbaoxian', item.c_no, item.bx_name, '2', item
						.c_date)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: item.c_no + ':' + res.data.msg,
							type: 'success'
						});

						this.loaddata();

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});
			}
		}


	}
</script>

<style scoped="scoped">
	.inline-bx,
	.inline-by,
	.inline-sc {
		display: inline-block;
		min-height: calc(100vh - 150px);
		max-height: calc(100vh - 150px);
		overflow: auto;
		vertical-align: top;
	}

	.tab_header td {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 14px;
		font-weight: 400;
	}

	.hulue-btn {
		display: inline-block;
		/* border: 1px solid black; */
		border-radius: 5px;
		background: #ff5500;
		text-align: center;
		padding: 2px 2px 2px 2px;
		/* font-size: 16px; */
		margin-left: 2px;
		margin-right: 2px;
	}

	.hulue-btn:hover {
		cursor: pointer;
		background-color: rgba(247, 61, 36, 0.986);
		/* font-size: 16px; */
	}
</style>
